"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M12.38 12.463h-1.272a.86.86 0 0 0-.84.838v2.024H9.121c-.037-.005-.112-.081-.117-.115v-4.134a.522.522 0 0 0-.503-.521l3.4-3.283 3.34 3.283a.522.522 0 0 0-.518.521v4.133c-.005.036-.08.112-.115.116H13.22V13.3a.864.864 0 0 0-.738-.832l-.102-.006ZM11.26.087c.358-.093.7-.112 1.042-.055l.224.048 7.576 2.55c.84.315 1.397 1.025 1.464 1.84l.006.165v9.859c0 6.757-9.14 9.378-9.528 9.487a.516.516 0 0 1-.141.019l-.071-.005-.07-.014c-.381-.107-9.225-2.644-9.52-9.153l-.007-.334V4.635c0-.89.483-1.604 1.3-1.942l.169-.063L11.259.087Zm.643.955c-.077 0-.155.006-.233.02l-.118.024L4.036 3.62c-.451.15-.71.454-.752.884l-.007.132v9.859c0 5.558 7.583 8.116 8.626 8.441l.326-.107c1.745-.594 8.046-3.08 8.292-8.034l.008-.3v-9.86c0-.494-.337-.824-.681-.983l-.095-.04L12.23 1.08a1.425 1.425 0 0 0-.327-.038Zm-.362 5.127a.524.524 0 0 1 .657-.056l.071.059 4.613 4.532a.523.523 0 0 1-.277.885l-.09.008h-.75v3.613c0 .564-.48 1.083-1.037 1.15l-.12.007h-1.91a.522.522 0 0 1-.512-.428l-.009-.094v-2.34h-.866v2.34a.523.523 0 0 1-.427.514l-.094.008H9.12c-.566 0-1.084-.481-1.15-1.037l-.008-.12v-3.613H7.21a.519.519 0 0 1-.421-.828l.06-.068 4.692-4.532Z",
    clipRule: "evenodd"
  })]
});